import React from "react";
import { Button, Box } from "@mui/material";

/**
 * 共通アクションボタン
 * - 左に白丸アイコン
 * - ピル型・立体ボタン
 * - 色味は呼び出し側で制御する
 */
export default function ActionButton({
  onClick,
  label,
  icon,
  showBadge = false,
  badgeText = "未入力あり",
  sx = {}, // スタイルを外から受け取る
  badgeSx = {}, // バッチのスタイルを外から受け取る
}) {
  return (
    <Button
      onClick={onClick}
      sx={{
        position: "relative",
        height: 40,
        borderRadius: "999px",

        pr: { xs: 3.5, sm: 6 },
        pl: icon ? { xs: 5.5, sm: 8 } : { xs: 3.5, sm: 6 },

        minWidth: { sm: 220 },
        width: { xs: "100%", sm: 240 },

        color: "#fff",
        fontWeight: 600,
        fontSize: "0.9rem",
        boxShadow: 4,
        transition: "all 0.15s ease",

        // テキストを中央寄せ
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "&:hover": {
          boxShadow: "none",
        },

        ...sx,
      }}
    >
      {/* 左固定のアイコン（ある時だけ描画） */}
      {icon && (
        <Box
          sx={{
            position: "absolute",
            left: 6,
            width: 30,
            height: 30,
            borderRadius: "50%",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      )}

      {/* 未入力バッジ */}
      {showBadge && (
        <Box
          sx={{
            position: "absolute",
            top: "-10px",
            right: "-6px",
            color: "#fff",
            fontSize: { xs: "0.55rem", sm: "0.65rem" },
            px: { xs: 0.6, sm: 1 },
            py: "1px",
            borderRadius: "999px",
            fontWeight: "bold",
            boxShadow: 1,
            ...badgeSx,
          }}
        >
          {badgeText}
        </Box>
      )}
      {label}
    </Button>
  );
}
